<template>
    <div class="c-panel c-panel--small">

        <div class="margin-b-32">
            <img src="/img/logo.svg" height="48" width="161">
        </div>

        <c-form @submit:valid="submit" ref="form">
            <c-input
                type="email"
                name="email"
                v-model="email"
                autocomplete="email"
                :label="'E-mailadres'"
                required />

            <c-password
                type="password"
                name="password"
                v-model="password"
                autocomplete="password"
                :label="'Wachtwoord'"
                required />

            <p class="color-alert" v-if="error">Deze combinatie van e-mailadres en wachtwoord is niet geldig.</p>

            <div class="c-callout c-callout--alert fs-xsmall margin-t-16" v-if="!browserCompatible">
                Deze applicatie werkt alleen onder de volgende browsers: Chrome, Edge of Safari
                <br /><br />
                Andere browsers worden niet ondersteunt door deze applicatie.
            </div>

            <c-button class="c-btn--expanded margin-t-32 margin-b-16" type="submit">Inloggen</c-button>

            <div class="text-center margin-b-16">
                <router-link :to="{name: 'password-forget'}" class="font-heading">Wachtwoord vergeten</router-link>
            </div>

        </c-form>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
    mixins: [ Form ],
    data() {
        return {
            error: false,
            email: '',
            password: '',
            browserCompatible: true,
        }
    },
    methods: {
        submit() {
            this.$store.dispatch('user/login', {
                email: this.email,
                password: this.password
            }).then((user) => {
                this.$router.push({ path: '/' });
            }).catch(e => {
                if(e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.error = true;
            });
        }
    },
    mounted() {
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const isEdge = /Edge/.test(navigator.userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        // Show notification if the browser is not Chrome, Edge, or Safari
        if (!isChrome && !isEdge && !isSafari) {
            this.browserCompatible = false;
        }
},
}
</script>